function getCustomerPortalLink(): string | null {
	const company = import.meta.env.VITE_AUTH_REALM;

	switch (company) {
		case 'Acorn':
			return 'https://portal.acorninsure.co.uk';
		case 'Motorcade':
			return 'https://portal.motorcade.co.uk';
		case 'Carrot':
			return 'https://portal.carrotinsurance.com';
		case 'Flag':
			return 'https://portal.flaginsurance.co.uk';
		case 'MyPolicy':
			return 'https://portal.mypolicy.co.uk';
		case 'StreetCover':
			return 'https://portal.streetcover.co.uk';
	}
	return null;
}
export default getCustomerPortalLink;
